import * as CryptoJS from 'crypto-js'; 

const Encryption = {
  "secretKey": "TECHNZONE_IHOS"
}

export class Utilities {
  

  static nullOrUndefined = (val: any): boolean => {
    if (val == null || val == '' || val == undefined) {
      return true;
    }

    return false;
  }

  static encrypt = (value: string): string => {
    let key = Encryption.secretKey;
    return encodeURIComponent(CryptoJS.AES.encrypt(value, key).toString());
  }

  static decrypt = (value: string): string => {
    let key = Encryption.secretKey;
    return CryptoJS.AES.decrypt(decodeURIComponent(value), key).toString(CryptoJS.enc.Utf8);
  }

}
